"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceDatePicker = void 0;
var react_1 = __importStar(require("react"));
var react_client_1 = require("@speechly/react-client");
var Calendar_1 = require("./Calendar");
var CalendarIcon_1 = require("./CalendarIcon");
var utils_1 = require("../utils");
var VoiceDatePicker = function (_a) {
    var label = _a.label, value = _a.value, defaultValue = _a.defaultValue, changeOnIntent = _a.changeOnIntent, changeOnEntityType = _a.changeOnEntityType, onChange = _a.onChange, onFinal = _a.onFinal, onBlur = _a.onBlur, onFocus = _a.onFocus, _b = _a.focused, focused = _b === void 0 ? true : _b;
    var inputEl = react_1.useRef(null);
    var _c = react_1.useState(false), _showCalendar = _c[0], _setShowCalendar = _c[1];
    var _d = react_1.useState(focused), _focused = _d[0], _setFocused = _d[1];
    var _e = react_1.useState(defaultValue), _date = _e[0], _setDate = _e[1];
    var _f = react_1.useState(defaultValue ? dateToString(defaultValue) : ''), _value = _f[0], _setValue = _f[1];
    var _g = react_1.useState(defaultValue ? dateToString(defaultValue) : ''), _lastGoodKnownValue = _g[0], _setLastGoodKnownValue = _g[1];
    var _h = react_1.useState(undefined), lastSegmentId = _h[0], setLastSegmentId = _h[1];
    var segment = react_client_1.useSpeechContext().segment;
    var _onChange = function (newValue) {
        _setValue(newValue);
        var newDate = stringToDate(newValue);
        if (newDate) {
            _setDate(newDate);
            if (onChange) {
                onChange(newDate);
            }
        }
    };
    function dateToString(date) {
        return (date.getDate()).toString().padStart(2, '0') + "/" + (date.getMonth() + 1).toString().padStart(2, '0') + "/" + date.getFullYear();
    }
    function stringToDate(value) {
        var regex = /([\d]+)\D([\d]+)\D(\d\d\d\d)/;
        var matches = value.match(regex);
        if (!matches)
            return null;
        var all = matches[0], day = matches[1], month = matches[2], year = matches[3];
        return new Date(month + " " + day + " " + year);
    }
    var _onFocus = function () {
        _setFocused(true);
        // use callback only to change parent state
        if (!focused && onFocus) {
            onFocus();
        }
    };
    var _onBlur = function () {
        // use callback only to change parent state
        if (_focused) {
            _setFocused(false);
            if (onBlur) {
                onBlur();
            }
        }
    };
    react_1.useEffect(function () {
        if (value) {
            _setValue(dateToString(value));
            _setDate(value);
        }
    }, [value]);
    react_1.useEffect(function () {
        if (focused && !_focused && inputEl != null && inputEl.current != null) {
            inputEl.current.focus();
        }
    }, [focused]);
    react_1.useEffect(function () {
        if (segment) {
            var newValue = null;
            var lastGoodKnownValue = _lastGoodKnownValue;
            // Update last good known value at new segment start
            var segmentId = segment.contextId + "/" + segment.id;
            if (segmentId !== lastSegmentId) {
                setLastSegmentId(segmentId);
                lastGoodKnownValue = value ? dateToString(value) : _value;
                _setLastGoodKnownValue(lastGoodKnownValue);
            }
            // Define newValue if the segment contains input targeted to this component
            if (!changeOnIntent || segment.intent.intent === changeOnIntent) {
                var entities = utils_1.formatEntities(segment.entities);
                if (entities[changeOnEntityType] !== undefined) {
                    newValue = dateToString(new Date(Date.parse(entities[changeOnEntityType])));
                }
            }
            // _onChange to newValue only only if defined: tentative input may retarget to another component at any time
            // otherwise reset to last good known value
            _onChange(newValue !== null ? newValue : lastGoodKnownValue);
            if (segment === null || segment === void 0 ? void 0 : segment.isFinal) {
                if (inputEl != null && inputEl.current != null) {
                    inputEl.current.blur();
                }
                if (onFinal) {
                    onFinal();
                }
            }
        }
    }, [segment]);
    var toggleCalendar = function (e) {
        e.preventDefault();
        _setShowCalendar(!_showCalendar);
    };
    var onDatePick = function (pickedDate) {
        _setShowCalendar(!_showCalendar);
        _onChange(dateToString(pickedDate));
    };
    return (react_1.default.createElement("div", { className: "widgetGroup inputText withCalendar" },
        react_1.default.createElement("label", null, label),
        react_1.default.createElement("input", { ref: inputEl, type: "text", name: changeOnEntityType, value: _value, onChange: function (event) { _onChange(event.target.value); }, onBlur: _onBlur, onFocus: _onFocus }),
        react_1.default.createElement("button", { className: "calendar-button", onClick: toggleCalendar },
            react_1.default.createElement(CalendarIcon_1.CalendarIcon, null)),
        _showCalendar && react_1.default.createElement(Calendar_1.Calendar, { date: _date, onDatePick: onDatePick })));
};
exports.VoiceDatePicker = VoiceDatePicker;
//# sourceMappingURL=VoiceDatePicker.js.map